import { gql } from '@apollo/client'

export const CAMPAIGN_SUBSCRIPTION_FIELDS = gql`
    fragment CampaignSubscriptionFields on CampaignSubscription {
        id
        campaignId
        planId
        type
        amount
        frequency
        status
        externalSubscriptionId
        externalPaymentIntentId
        currentPeriodStart
        currentPeriodEnd
        cancelAtPeriodEnd
        createdAt
        amountPerMonth
        creativesQuantity
        scheduledFrequency
        scheduledPeriodEnd
    }
`

export const GET_PLANS = gql`
    query GetPlans($type: String) {
        plans(type: $type) {
            id
            name
            type
            amount
            amountPerMonth
            creativesQuantity
            frequency
            tier
        }
    }
`

export const GET_CAMPAIGN_SUBSCRIPTIONS = gql`
    ${CAMPAIGN_SUBSCRIPTION_FIELDS}
    query GetCampaignSubscriptions($campaignId: ID!) {
        getCampaignSubscriptions(campaignId: $campaignId) {
            ...CampaignSubscriptionFields
            # Not in the shared fragment: the mutations that use it must keep working while a deployment is
            # still on a backend without these fields
            paymentsOnHold
            paymentsHoldUntil
        }
    }
`

export const RETRY_CAMPAIGN_SUBSCRIPTION_PAYMENT = gql`
    ${CAMPAIGN_SUBSCRIPTION_FIELDS}
    mutation RetryCampaignSubscriptionPayment($input: RetryCampaignSubscriptionPaymentInput!) {
        retryCampaignSubscriptionPayment(input: $input) {
            outcome
            campaignSystemStatus
            actionUrl
            subscription {
                ...CampaignSubscriptionFields
            }
        }
    }
`

export const RECOVER_PAID_CAMPAIGN_ACTIVATION = gql`
    mutation RecoverPaidCampaignActivation($campaignId: ID!) {
        recoverPaidCampaignActivation(campaignId: $campaignId) {
            id
            systemStatus
        }
    }
`

export const COMPLETE_DRAFT_CAMPAIGN = gql`
    ${CAMPAIGN_SUBSCRIPTION_FIELDS}
    mutation CompleteDraftCampaign($input: CompleteDraftCampaignInput!) {
        completeDraftCampaign(input: $input) {
            id
            name
            systemStatus
            subscriptions {
                ...CampaignSubscriptionFields
            }
            failedSubscriptions {
                type
                message
            }
        }
    }
`

export const CREATE_CAMPAIGN_WITH_SUBSCRIPTIONS = gql`
    ${CAMPAIGN_SUBSCRIPTION_FIELDS}
    mutation CreateCampaignWithSubscriptions(
        $userId: ID!
        $input: CreateCampaignWithSubscriptionsInput!
    ) {
        createCampaignWithSubscriptions(userId: $userId, input: $input) {
            id
            name
            systemStatus
            subscriptions {
                ...CampaignSubscriptionFields
            }
            failedSubscriptions {
                type
                message
            }
        }
    }
`

export const CREATE_CAMPAIGN_SUBSCRIPTION = gql`
    ${CAMPAIGN_SUBSCRIPTION_FIELDS}
    mutation CreateCampaignSubscription($input: CreateCampaignSubscriptionInput!) {
        createCampaignSubscription(input: $input) {
            ...CampaignSubscriptionFields
        }
    }
`

export const EXTEND_CAMPAIGN_SUBSCRIPTION = gql`
    ${CAMPAIGN_SUBSCRIPTION_FIELDS}
    mutation ExtendCampaignSubscription($input: ExtendCampaignSubscriptionInput!) {
        extendCampaignSubscription(input: $input) {
            ...CampaignSubscriptionFields
        }
    }
`

export const UPDATE_CAMPAIGN_SUBSCRIPTION_AUTO_RENEW = gql`
    ${CAMPAIGN_SUBSCRIPTION_FIELDS}
    mutation UpdateCampaignSubscriptionAutoRenew($input: UpdateCampaignSubscriptionAutoRenewInput!) {
        updateCampaignSubscriptionAutoRenew(input: $input) {
            ...CampaignSubscriptionFields
        }
    }
`

export const GET_CAMPAIGN_CREATIVES_QUOTA = gql`
    query GetCampaignCreativesQuota($campaignId: ID!) {
        getCampaignCreativesQuota(campaignId: $campaignId) {
            used
            purchased
            available
            isLegacy
        }
    }
`

export const UPDATE_PAYMENT_METHOD = gql`
    mutation UpdatePaymentMethod($paymentMethodInput: PaymentMethodInput!) {
        updatePaymentMethod(paymentMethodInput: $paymentMethodInput) {
            id
            email
            paymentMethodId
            cardBrand
            cardExpMonth
            cardExpYear
            cardLastDigits
        }
    }
`
